<template>
    <v-main>
        <!-- <dashboard-core-system-bar /> -->
        <transition :name="transition" :mode="transitionMode">
            <router-view />
        </transition>
    </v-main>
</template>

<script>
export default {
    name: "DashboardCoreView",

    // components: {
    //     DashboardCoreSystemBar: () => import("./SystemBar.vue"),
    // TODO: add when operator access is implemented in APIv2
    // },

    data() {
        return {
            transition: null,
            transitionMode: null,
        };
    },

    watch: {
        $route(to, from) {
            if (from.name == "Login" && ["Register", "Account Help"].includes(to.name)) {
                this.transition = "scroll-down";
                this.transitionMode = "out-in";
            } else if (to.name == "Login" && ["Register", "Account Help"].includes(from.name)) {
                this.transition = "scroll-up";
                this.transitionMode = "out-in";
            } else if (from.name == "Login" || to.name == "Login") {
                this.transition = "fade";
                this.transitionMode = "out-in";
            } else {
                this.transition = null;
                this.transitionMode = null;
            }
        },
    },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s linear;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
.fastfade-enter-active,
.fastfade-leave-active {
    transition: opacity 0.1s linear;
}
.fastfade-enter,
.fastfade-leave-active {
    opacity: 0;
}
.scroll-down-enter-active,
.scroll-down-leave-active,
.scroll-up-enter-active,
.scroll-up-leave-active {
    transition-duration: 0.2s;
    transition-property: height, width, opacity, transform;
    transition-timing-function: ease;
    overflow: hidden;
}

.scroll-down-enter,
.scroll-up-leave-active {
    opacity: 0;
    transform: translate(0, 60px);
}
.scroll-down-leave-active,
.scroll-up-enter {
    opacity: 0;
    transform: translate(0, -60px);
}
</style>
